module.exports = "<div class='navigation-bar-desktop-spacer'></div>"